import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Members/Profile/Actions';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

import useTimeZones from 'components/Common/TimeZones/Hooks/useTimeZones';

export default function TimeZone({ refreshParent }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const { timeZones } = useTimeZones();

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    time_zone: Yup.string().typeError('Time Zone is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      member.id,
      {
        ...values,
      },
      true,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        refreshParent();
        navigate(-1, { state: { refreshTimeZone: 'test' } });
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal size="lg" show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          time_zone: member.time_zone,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">

            <Row>
              <Col>
                <HorizontalSelectField
                  name="time_zone"
                  label="Time Zone"
                  placeholder={timeZones === null ? 'Loading...' : 'Select Time Zone'}
                  options={timeZones === null ? [] : timeZones}
                  required
                />
              </Col>

            </Row>

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

TimeZone.propTypes = {
  refreshParent: PropTypes.func,
};

TimeZone.defaultProps = {
  refreshParent: () => {},
};
